import { type AuthUser } from "wasp/auth";
import Breadcrumb from "../../layout/Breadcrumb";
import DefaultLayout from "../../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../../useRedirectHomeUnlessUserIsAdmin";
import ArticlesTable from "./ArticlesTable";

const ArticlesDashboard = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName="Articles Management" />
      <div className="flex flex-col gap-10">
        <ArticlesTable />
      </div>
    </DefaultLayout>
  );
};

export default ArticlesDashboard;
